export default __webpack_public_path__ + "static/media/IrisCityLogo.fe62b25c.png";